<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xJY9e/images/cover.jpg?1684515201130" alt="This image is the cover for the book Violet Path"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Violet Path
      </h1>
      <p class="bookDescription body article font2">
        <p>Meticulously trained to be a merciless fighting machine from a young age, Alexia, a startling teen with electrifying violet eyes and a stealthy mercenary mind, now faces her destiny to lead an army through its final stages of world domination. Meanwhile, Matthew, mastermind of the Long War and her overloard, in his bloodlust to fulfill his self-appointed destiny, overlooks a key fray in the rope: the rebellious nature of a teenager.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Olivia Lodise
      </h2>
      
      <p class="authorDescription body article">Olivia Lodise was born in 1995, lives in Atlanta, Georgia, and graduatehigh school with the class of 2013. Fluent in almost three languages, the power of words has inspired her. She truly believes imagination is the key to being limitless. Her travel experiences to France and the Trans-Siberian Orient Express have impacted her immensely and often affect her stories as they offer new views on the world. Her first novel, "Violet Path," started as a simple school written assignment but quickly became a prominent hobby, and it is only the beginning. Olivia prefers writing by hand because it offers her a more concrete emotional connection with her work. She sees the stories as new realms waiting to be explored and shaped, and words are merely a tool with infinite possibilities to express dreams.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0701305a